<template>
  <header :class="{ 'transparent': transparent }">
    <nav>
      <span class="mr-2">My Page :</span>
      <a href="https://mypage.williesenglish.jp/login">https://mypage.williesenglish.jp/login</a>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    transparent: Boolean
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  background-color: $primary-color;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16),0 2px 10px 0 rgba(0,0,0,0.12);

  &.transparent {
    background-color: transparent;
    box-shadow: none;
  }
}

nav {
  min-height: 54px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px;
  color: white;
  font-weight: bold;

  @include mq(lg) {
    padding: 20px;
  }

  a {
    color: white;
  }
}
</style>
